export default "__VITE_ASSET__DCN70I$P__"